import Api from '@/services/Api'

export default {
  index (params) {
    return Api().post('device', params)
  },
  create (params) {
    return Api().post('deviceNew', params)
  },
  show (params) {
    return Api().post('deviceShow', params)
  },
  update (params) {
    return Api().post('deviceUpdate', params)
  },
  state (params) {
    return Api().post('deviceState', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/DeviceService.js